"use client"

import Button from "@src/components/Button"
import { NearIcon, NearLogoIcon } from "@src/icons"
import clsx from "clsx"
import Link from "next/link"
import { usePathname } from "next/navigation"
import { useEffect, useState } from "react"

type ScrollState = "top" | "scrolled" | "past-threshold"

export const MarketingHeader = () => {
  const [scrollState, setScrollState] = useState<ScrollState>("top")
  const pathname = usePathname()

  useEffect(() => {
    const handleScroll = () => {
      const y = window.scrollY
      setScrollState(y >= 250 ? "past-threshold" : y > 0 ? "scrolled" : "top")
    }
    handleScroll()
    window.addEventListener("scroll", handleScroll, { passive: true })
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const isHomePage = pathname === "/"
  const shouldShowLoginButton = !isHomePage || scrollState === "past-threshold"

  return (
    <header
      className={clsx(
        "sticky top-0 z-20 w-full border-b bg-white px-5 transition-all duration-150",
        scrollState === "top"
          ? "h-28 border-transparent"
          : "h-18 border-gray-200"
      )}
    >
      <div className="mx-auto flex h-full max-w-5xl items-center justify-between">
        <Link href="/" className="flex items-center gap-2.5">
          <NearIcon className="size-9 shrink-0 text-black" />
          <NearLogoIcon className="h-3.5 shrink-0" />
          <span className="sr-only">Home</span>
        </Link>
        {shouldShowLoginButton && (
          <Button
            size="lg"
            href="/login"
            variant="dark"
            className="fade-in animate-in duration-150"
          >
            <span className="px-2">Sign in</span>
          </Button>
        )}
      </div>
    </header>
  )
}
